/* eslint-disable max-len */

export const createQueryStringFromFilters = (filters) => Object.keys(filters)
  .map(key => filters[key]
    .map(value => {
      if (typeof value === 'object' && (value.min !== undefined || value.max !== undefined)) {
        const parts = [];
        if (value.min !== undefined) parts.push(`min=${encodeURIComponent(value.min)}`);
        if (value.max !== undefined) parts.push(`max=${encodeURIComponent(value.max)}`);
        return `advanced_keyword=${encodeURIComponent(key)},${parts.join(',')}`;
      } else {
        return `advanced_keyword=${encodeURIComponent(key)},${encodeURIComponent(value)}`;
      }
    })
    .join('&'))
  .join('&');
